import React from 'react';
import { useTranslation } from 'react-i18next';

const UserProfile = () => {
  const { t } = useTranslation();
  return <>{t('common.user_profile', 'User profile')}</>;
};

export default UserProfile;
